// 弹窗类型
export enum ModalTypeEnum {
  NOTICE_MODAL = 'NOTICE_MODAL', // 公告
  HORSEMAN_MODAL = 'HORSEMAN_MODAL', // 跑马灯
  REGISTER_BONUS_MODAL = 'REGISTER_BONUS_MODAL', // 注册红包
  TOP_DOWNLOAD_MODAL = 'TOP_DOWNLOAD_MODAL', // 顶部下载
  BOTTOM_DOWNLOAD_MODAL = 'BOTTOM_DOWNLOAD_MODAL', // 底部下载
  LOGIN_REGISTER_MODAL = 'LOGIN_REGISTER_MODAL', // 登录注册
  DEPOSIT_BONUS = 'DEPOSIT_BONUS', // 充值奖励
  SIGN_IN = 'SIGN_IN', // 签到
  LOTTERY_WHEEL = 'LOTTERY_WHEEL', // 幸运转盘
  RED_PACKETS_RAIN = 'RED_PACKETS_RAIN', // 红包雨
  RECOVER_PASSWORD = 'RECOVER_PASSWORD', // 找回密码
}
